import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-health-pillar',
  imports: [],
  templateUrl: './health-pillar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './health-pillar.component.css'
})
export class HealthPillarComponent {

}
